import no_signal from '@/assets/img/views/single/no_signal.png';
import signal_1 from '@/assets/img/views/single/signal_1.png';
import signal_2 from '@/assets/img/views/single/signal_2.png';
import signal_3 from '@/assets/img/views/single/signal_3.png';
import signal_4 from '@/assets/img/views/single/signal_4.png';
import signal_5 from '@/assets/img/views/single/signal_5.png';
import { clstagStr } from './util';
/* eslint-disable no-unused-vars */
export enum PermissionTab {
  SPV_REALTIME = 'spv_realtime',
  SPV_IMPASSABLE_AREA = 'spv_impassable_area',
  SPV_DRIVE_ENABLE = 'spv_drive_enable',
  SPV_ERROR_INFO = 'spv_error_info',
  SPV_OPERATE_LOG = 'spv_operate_log',
  SPV_TRACK_HISTORY = 'spv_track_history',
  SPV_EMERGENCY_STOP = 'spv_emergency_stop',
  SPV_DATA_ANALYSIS = 'spv_data_analysis',
  SPV_ACCIDENT_ANALYSIS = 'spv_accident_analysis',
  SPV_ACCIDENT_INVESTIGATION = 'spv_accident_investigation',
  SPV_ALARM_HISTORY = 'spv_alarm_history',
  SPV_ACCIDENT_HISTORY = 'spv_accident_history', // 监控工单-事故管理
  SPV_ERROR_HISTORY = 'spv_error_history', // 监控工单-错误信息
  SPV_EVENT_DATA = 'spv_event_data', // 监控工单-事件信息
  SPV_OPS_DATA = 'spv_ops_data', // 监控工单-运维工单
  SPV_PROBLEM_REPORT = 'spv_problem_report', // 监控工单-问题提报工单
  SPV_COCKPIT_DATA = 'spv_cockpit_data', // 监控工单-座席信息
  SPV_TECH_SUPPORT_DATA = 'spv_tech_support_data', // 监控工单-技术支持信息
  SPV_COCKPIT_TEAM_DATA = 'spv_cockpit_team_data', // 监控工单-座席团队信息
  SPV_THREE_DIMENSION = 'spv_three_dimension',
  SPV_WORKORDER_RECORD = 'spv_workOrder_record',
  SPV_EVENT_RECORD = 'spv_event_record',
  SPV_MANUAL_EVENT_RECORD = 'spv_manual_event_record',
}

export enum PermissionButton {
  SPV_ORDER_DETAIL = 'spv_order_detail',
  SPV_CHECK_ORDER = 'spv_check_order',
  SPV_ORDER_OPERATIONS = 'spv_order_operations',
  SPV_ALARM_DRAWER = 'spv_alarm_drawer',
  SPV_VIDEO = 'spv_video',
  SPV_LOCAL_VIEW = 'spv_local_view',
  SPV_CONTROL_LIST = 'spv_control_list',
  SPV_JIRA_REPORT = 'spv_jira_report',
  SPV_ASSIST_JIRA_REPORT = 'spv_assist_jira_report',
  SPV_ISSUE_HANDLE = 'spv_issue_handle',
  VEHILCE_BASIC_INFO_DETAIL = 'vehicle_basic_info_detail',
  SPV_ISSUE_VIEW = 'spv_issue_view',
  SPV_ISSUE_REPORT = 'spv_issue_report',
  SPV_WORK_ORDER_COLUMN_ISSUE_REPORT = 'spv_work_order_column_issue_report',
  SPV_ADD_AREAS = 'spv_add_areas',
  SPV_DELETE_AREAS = 'spv_delete_areas',
  SPV_ENABLE_AREAS = 'spv_enable_areas',
  SPV_EDIT_RECORD = 'spv_edit_record',
  SPV_COMMAND_TERMINAL = 'spv_command_terminal',
  SPV_ADD_MANUAL_EVENT_BTN = 'spv_add_manual_event_btn',
  VEHICLE_INIT_PREVIEW_BTN = 'vehicle_init_info',
  SPV_SCHEDULE_DETAIL = 'spv_schedule_detail',
  TICKET_OPERATION = 'spv_ticket_operation',
  SPV_CALL_FRONT = 'spv_call_front',
  SPV_LISTENING_MODE = 'SPV_LISTENING_MODE',
  SPV_WATCH_CAR_MODE = 'SPV_WATCH_CAR_MODE',
  SPV_PATROL_MODE = 'SPV_PATROL_MODE',
  SPV_TECHSUPORT_EDIT = 'spv_techsuport_edit_btn',
  SPV_SAFTY_GROUP_EDIT = 'spv_saftygroup_edit_btn',
  MAP_UPDATE_DETAIL_BTN = 'map_update_detail_btn',
  MENU_ACCIDENT_MANAGEMENT = 'menu_accident_management',
  MENU_ACCIDENT_DASHBOARD = 'menu_accident_dashboard',
  INCIDENT_FOLLOWUP_TICKET = 'incident_followup_ticket',
  PROBLEM_REPORT = 'problem_report',
  RENTAL_CAR_ACCIDENT_MANAGEMENT = 'rental_car_accident_management',
  RENTAL_CAR_OPERATION_EXCEPTION = 'rental_car_operation_exception',
}

export enum WorkOderProgress {
  WAITING = '待处理',
  PROCESS = '处理中',
  FINISH = '完成',
}

export const WorkOrderOperateResult = new Map([
  ['OPERATION_ALARM', '运营报警'],
  ['EXCEPTION_REMIND', '异常提醒'],
  ['VEHICLE_ALARM', '车辆报警'],
  ['SUPPORT_PROCESS', '技术支持处理中'],
  ['DEVELOPER_PROCESS', '研发处理中'],
  ['OPERATOR_PROCESS', '运营处理中'],
  ['OPERATION_RESUME', '运营恢复'],
  ['OPERATION_ABORT', '运营终止'],
]);

export enum CLSTAG {
  // 埋点一期
  // Header Tab
  RealtimeMonitor = 'realtime__1682475498880|3', // 实时监控
  OpenlayersMap = 'realtime__1682475498880|2', // 动态地图
  WorkOrderTab = 'realtime__1682427372512|1', // 监控工单
  ShadowSystemTab = 'realtime__1682475498880|1', // 车辆影子
  MonitorLogTab = 'realtime__1682427372512|12', // 监控日志
  MonitorDataTab = 'realtime__1682427372512|13', // 数据监控
  CockpitManageTab = 'realtime__1683267499373|4', // 座席管理

  // 多车页
  StationVehicleSearch = 'realtime__1682427372512|2', // 多车页_站点车号搜索
  LeftDrawerOpenClose = 'realtime__1682427372512|3', // 多车页_左侧抽屉展开收起
  ConnectionLostAbnormal = 'realtime__1682426427874|20', // 多车页_失联及异常类型
  Normal = 'realtime__1682426427874|5', // 多车页_正常类型
  Offline = 'realtime__1682426427874|16', // 多车页_离线类型
  All = 'realtime__1682426427874|17', // 多车页_全部类型
  Collected = 'realtime__1682426427874|18', // 多车页_收藏类型
  ConnectionLost = 'realtime__1682425684903|1', // 多车页_失联场景
  VehicleCrash = 'realtime__1682425684903|8', // 多车页_失联场景
  ManualReport = 'realtime__1682425684903|17', // 多车页_人工告警场景
  SensorError = 'realtime__1682425684903|9', // 多车页_传感器异常场景
  OperationAlarm = 'realtime__1682425684903|10', // 多车页_运营告警场景
  BootAlarm = 'realtime__1682425684903|15', // 多车页_开机异常场景
  IntersectionAbnormal = 'realtime__1682425684903|18', // 多车页_路口异常场景
  Stop = 'realtime__1682425684903|19', // 多车页_停车场景
  CloudWarn = 'realtime__1682425684903|20', // 多车页_云端预警场景
  LowBattery = 'realtime__1682425684903|16', // 多车页_电量场景
  LowPressure = 'realtime__1682425684903|7', // 多车页_胎压场景
  HardwareError = 'realtime___1756197589781|1', // 多车页_硬件异常
  NetworkSignal = 'realtime___1756197589781|2', // 多车页_网络信号

  // 单车页操作按钮
  PlayVideo = 'realtime__1682426427874|6', // 打开视频
  StopVideo = 'realtime__1682426427874|8', // 关闭视频
  RemoteCall = 'realtime__1683267499373|10', // 远程喊话
  PlayAudio = 'realtime__1683267499373|11', // 开启收音
  PauseAudio = 'realtime__1683267499373|12', // 关闭收音
  ExpandTrafficLight = 'realtime__1683267499373|13', // 红绿灯展开
  CollapseTrafficLight = 'realtime__1683267499373|14', // 红绿灯收起
  StopBtnClick = 'realtime__1682426427874|7', // 急停
  RecoverBtnClick = 'realtime__1682426427874|1', // 恢复
  RemoteControl = 'realtime__1682426427874|2', // 进入遥控
  PassTrafficLightBtnClick = 'realtime__1682426427874|3', // 通过路口
  CancelTrafficLightBtnClick = 'realtime__1683267499373|9', // 取消通过路口
  AsArrivedBtn = 'realtime__1682426427874|4', // 视同到达
  RemoveStop = 'realtime__1682426427874|9', // 解除拍停
  PowerOff = 'realtime__1682426427874|10', // 远程下电
  ReBoot = 'realtime__1682425684903|2', // 断电重启
  ReStart = 'realtime__1682425684903|3', // 软件重启
  PowerOn = 'realtime__1728715455046|79', // 远程开机
  ResetGps = 'realtime__1682425684903|4', // 定位重置
  ComputeBtn = 'realtime__1683267499373|5', // 远程工具-compute
  ControlBtn = 'realtime__1683267499373|6', // 远程工具-control
  CompleteIssueJira = 'realtime__1683267499373|7', // 结单-点选一键提报
  CallFrontliner = 'realtime__1683267499373|8', // 呼叫一线
  JiraReport = 'realtime__1682426427874|11', // jira提报
  CompleteIssue = 'realtime__1682425684903|11', // 结单按钮
  TransferIssue = 'realtime__1682425684903|12', // 转单按钮
  DiscardIssue = 'realtime__1682425684903|13', // 抛单按钮
  OnHoldIssue = 'realtime__1682425684903|14', // 挂单按钮
  EnableTab = 'realtime__1683267499373|1', // 使能tab
  ErrorInfoTab = 'realtime__1682426427874|12', // 错误信息tab
  OperationLog = 'realtime__1682426427874|13', // 操作日志tab
  Accident_investigation = 'realtime__1683267499373|3', //事故排查Tab
  QQMapBtn = 'realtime__1682426427874|14', // 2D地图按钮
  ThreeMonitor = 'realtime__1682426427874|15', // 3D地图按钮

  // 工单
  CockpitBoard = 'realtime__1726816968981|1', // 座席管理_座席看板tab
  CheckVehicle = 'realtime__1726816968981|2', // 座席管理_座席看板-查看车辆
  CheckIssueDetail = 'realtime__1726816968981|3', // 座席管理_座席看板-查看工单
  RemindIssue = 'realtime__1726816968981|4', // 座席管理_座席看板-催单
  IssueBoard = 'realtime__1726816968981|5', // 座席管理_工单看板tab
  IssueBoard_RemindIssue = 'realtime__1726816968981|6', // 座席管理_工单看板-催单
  IssueBoard_CheckIssueDetail = 'realtime__1726816968981|7', // 座席管理_工单看板-查看工单
  IssueBoard_AllocateIssue = 'realtime__1726816968981|8', // 座席管理_工单看板-派单
  BindVehicle = 'realtime__1726816968981|9', // 座席管理_车辆绑定tab

  ClickCockpitId = 'realtime__1726816968981|10', // 座席模式_工单-座席id
  Rest = 'realtime__1726816968981|11', // 座席模式_工单-休息
  CompleteThenRest = 'realtime__1726816968981|12', // 座席模式_工单-结单后休息
  Work = 'realtime__1726816968981|13', // 座席模式_工单-工作
  IssueCardTransfer = 'realtime__1726816968981|14', // 座席模式_工单卡片转单
  IssueCardComplete = 'realtime__1726816968981|15', // 座席模式_工单卡片结单
  IssueCardDiscard = 'realtime__1726816968981|16', // 座席模式_工单卡片抛单
  IssueCardHold = 'realtime__1726816968981|17', // 座席模式_工单卡片挂单
  IssueCardExpandFold = 'realtime__1726816968981|18', // 座席模式_工单卡片展开收起
  IssueCardOpenVideo = 'realtime__1726816968981|19', // 座席模式_工单卡片开启视频
  IssueCardCloseVideo = 'realtime__1726816968981|20', // 座席模式_工单卡片关闭视频
  IssueCardToSingle = 'realtime__1726816968981|21', // 座席模式_工单卡片进入单车页
  IssueNotificationToSingle = 'realtime__1726816968981|22', // 座席模式_工单卡片进入单车页
  WorkOrderDrawerOpenClose = 'realtime__1682426427874|19', // 工单_工单抽屉展开收起

  // 埋点二期
  // 多车页
  MultiPage_AddAttention = 'realtime__1727334823926|2', // 收藏按钮
  MultiPage_RemoveAttention = 'realtime__1727334823926|3', // 取消收藏按钮
  MultiPage_Sort_BusinessType = 'realtime__1727334823926|4', // 排序方式-业务
  MultiPage_Sort_VehicleName = 'realtime__1727334823926|5', // 排序方式-车号
  MultiPage_Sort_Power = 'realtime__1727334823926|6', // 排序方式-电量
  MultiPage_Sort_Station = 'realtime__1727334823926|7', // 排序方式-营业部
  MultiPage_VehicleType_Select = 'realtime__1727334823926|8', // 车辆类型筛选
  MultiPage_ScheduleModal = 'realtime__1727334823926|9', // 车辆卡片_调度详情
  MultiPage_CheckDataAnalysis = 'realtime__1727334823926|10', // 车辆卡片_调度详情_查看数据分析按钮
  MultiPage_BusinessType_Select = 'realtime__1727334823926|11', // 车辆业务筛选
  MultiPage_MapMode = 'realtime__1727334823926|12', // 地图模式
  MultiPage_BoardMode = 'realtime__1727334823926|13', // 看板模式

  // 单车页
  SinglePage_ZoomInFrontVideo = 'realtime__1727334823926|14', // 放大前路视频
  SinglePage_ZoomInBackVideo = 'realtime__1727334823926|15', // 放大后路视频
  SinglePage_ZoomInLeftVideo = 'realtime__1727334823926|16', // 放大左路视频
  SinglePage_ZoomInRightVideo = 'realtime__1727334823926|17', // 放大右路视频
  SinglePage_ZoomOutFrontVideo = 'realtime__1727334823926|18', // 关闭放大前路视频
  SinglePage_ZoomOutBackVideo = 'realtime__1727334823926|19', // 关闭放大后路视频
  SinglePage_ZoomOutLeftVideo = 'realtime__1727334823926|20', // 关闭放大左路视频
  SinglePage_ZoomOutRightVideo = 'realtime__1727334823926|21', // 关闭放大右路视频
  SinglePage_3DAngle_P = 'realtime__1727334823926|22', // 3D-P
  SinglePage_3DAngle_T = 'realtime__1727334823926|23', // 3D-T
  SinglePage_3DAngle_F = 'realtime__1727334823926|24', // 3D-F
  SinglePage_WorkOrderRecord = 'realtime__1727334823926|25', // 工单记录
  SinglePage_EventRecord = 'realtime__1727334823926|26', // 事件记录
  SinglePage_ManualEventRecord = 'realtime__1727334823926|27', // 人工记录
  SinglePage_AddAttention = 'realtime__1727334823926|28', // 收藏按钮
  SinglePage_RemoveAttention = 'realtime__1727334823926|29', // 取消收藏按钮
  SinglePage_StationDetail = 'realtime__1727334823926|30', // 站点详情
  SinglePage_CheckOrders = 'realtime__1727334823926|31', // 订单按钮
  SinglePage_CheckSchedule = 'realtime__1727334823926|31', // 调度按钮

  // 监控工单
  WorkOrderPage_AccidentHistoryTab = 'realtime__1727334823926|33', // 事故管理tab
  WorkOrderPage_AccidentHistorySearch = 'realtime__1727334823926|34', // 事故管理查询
  WorkOrderPage_ErrorHistoryTab = 'realtime__1727334823926|35', // 错误信息tab
  WorkOrderPage_ErrorHistorySearch = 'realtime__1727334823926|36', // 错误信息查询
  WorkOrderPage_EventDataTab = 'realtime__1727334823926|37', // 事件信息tab
  WorkOrderPage_EventDataSearch = 'realtime__1727334823926|38', // 事件信息查询
  WorkOrderPage_OpsDataTab = 'realtime__1727334823926|39', // 运维工单tab
  WorkOrderPage_OpsDataSearch = 'realtime__1727334823926|40', // 运维工单查询
  WorkOrderPage_ProblemReportTab = 'realtime__1727334823926|41', // 问题提报工单tab
  WorkOrderPage_ProblemReportSearch = 'realtime__1727334823926|42', // 问题提报工单查询
  WorkOrderPage_CockpitDataTab = 'realtime__1727334823926|43', // 座席信息tab
  WorkOrderPage_CockpitDataSearch = 'realtime__1727334823926|44', // 座席信息查询
  WorkOrderPage_TechSupportDataTab = 'realtime__1727334823926|45', // 技术支持信息tab
  WorkOrderPage_TechSupportDataSearch = 'realtime__1727334823926|46', // 技术支持信息查询
  WorkOrderPage_CockpitTeamDataTab = 'realtime__1727334823926|47', // 座席团队信息tab
  WorkOrderPage_CockpitTeamDataSearch = 'realtime__1727334823926|48', // 座席团队信息查询
  WorkOrderPage_EventData_CheckError = 'realtime__1727334823926|49', // 事件信息-查看错误
  WorkOrderPage_EventData_EventDetail = 'realtime__1727334823926|50', // 事件信息-事件详情
  WorkOrderPage_EventData_GoSingle = 'realtime__1727334823926|51', // 事件信息-进入单车页
  WorkOrderPage_OpsData_CheckDetail = 'realtime__1727334823926|52', // 运维工单-查看详情
  WorkOrderPage_OpsData_GoSingle = 'realtime__1727334823926|53', // 运维工单-进入单车页
}

export const coordType = 'GCJ02';
export const pageInfo: any = {
  spv_realtime: {
    key: 'realtime',
    label: '实时监控',
    navigator: '/app/realtime',
    clstag: CLSTAG.RealtimeMonitor,
  },
  spv_impassable_area: {
    key: 'virtualObjectView',
    label: '动态地图',
    navigator: '/app/mapeditor',
    clstag: CLSTAG.OpenlayersMap,
  },
  spv_alarm_info: {
    key: 'warningListView',
    label: '监控工单',
    navigator: '/app/warnings',
    clstag: CLSTAG.WorkOrderTab,
  },
  spv_shadow_system: {
    key: 'shadowSystemView',
    label: '车辆影子',
    navigator: '/app/shadowsystem',
    clstag: CLSTAG.ShadowSystemTab,
  },
  spv_operate_log: {
    key: 'operationsLogView',
    label: '监控日志',
    navigator: '/app/operations',
    clstag: CLSTAG.MonitorLogTab,
  },
  spv_data_monitor: {
    key: 'dataMonitor',
    label: '数据监控',
    navigator: 'https://rover-bi.jd.com/login',
    clstag: CLSTAG.MonitorDataTab,
  },
  spv_cockpitManage: {
    key: 'cockpitManage',
    label: '座席管理',
    navigator: '/app/cockpitManage',
    clstag: CLSTAG.CockpitManageTab,
  },
  accidentManage: {
    key: 'accidentManage',
    label: '故障管理',
    navigator: '/app/accidentmanage',
  },
  data_collection_task: {
    key: 'dataCollectionTask',
    label: '数据采集',
    navigator: '/app/collectiontask',
  },
};

export const tabListPermission = new Map([
  [PermissionTab.SPV_OPS_DATA, '运维工单'],
  [PermissionTab.SPV_EVENT_DATA, '事件'],
  [PermissionTab.SPV_ERROR_HISTORY, '错误信息'],
  [PermissionTab.SPV_PROBLEM_REPORT, '问题提报工单'],
  [PermissionTab.SPV_COCKPIT_DATA, '座席'],
  [PermissionTab.SPV_COCKPIT_TEAM_DATA, '远驾团队'],
  [PermissionTab.SPV_TECH_SUPPORT_DATA, '技术支持'],
  // [PermissionTab.SPV_ACCIDENT_HISTORY, '事故管理'],
]);
export const tabKeys = {
  threeDimension: 'threeDimension',
  workOrderRecord: 'workOrderRecord',
  eventRecord: 'eventRecord',
  manualEventRecord: 'manualEventRecord',
};
export enum SortType {
  ASC = 0,
  DESC = 1,
}

export enum CoordType {
  UTM = 2,
}

export enum CoordStatus {
  USING = 1,
  DELETED = 2,
}

export enum EffectState {
  ENABLE = 1,
  DISABLED = 0,
}

export enum EffectType {
  PERMANENT = 1,
  SEASONAL = 2,
}

export const EffectStateText = new Map([
  [EffectState.ENABLE, '启用'],
  [EffectState.DISABLED, '停用'],
]);

export const EffectTypeText = new Map([
  [EffectType.PERMANENT, '长期生效'],
  [EffectType.SEASONAL, '周期生效'],
]);

export enum AnchorLayerType {
  MOVE_ROUND = 1,
  ROAD_CLOSED = 2,
  NO_PARKING = 3,
}

export const AnchorLayerText = new Map([
  [AnchorLayerType.MOVE_ROUND, '绕行障碍物'],
  [AnchorLayerType.ROAD_CLOSED, '封路障碍物'],
  [AnchorLayerType.NO_PARKING, '小区禁停区'],
]);

export enum SortFields {
  ObjId = 'objid',
  Type = 'type',
  Duration = 'duration',
  Status = 'status',
  UserName = 'userName',
  TimeStamp = 'timestamp',
}

export enum GlobalEventName {
  JDX_MENU_CLICK = 'menuClick',
  JDX_HIGHLIGHT_ROUTING_PATH = 'highlight_routing_path',
  JDX_REMOVE_HIGHLIGHT_ROUTING_PATH = 'remove_highlight_routing_path',
  JDX_CHANGE_HEADER_TAB_BTN = 'change_header_tab_btn',
  JDX_FILE_UPLOAD_STATUS = 'file_upload_status', //文件上传状态
}

export const videoDelayLimit = 1; // 视频延时阈值1s

export enum VehicleBusinessType {
  ALL = 'ALL',
  DISPATCH = 'DISPATCH',
  VENDING = 'VENDING',
}

export enum CategoryText {
  CONNECTION_LOST = '失联',
  VEHICLE_CRASH = '防撞',
  SENSOR_ERROR = '传感器异常',
  OPERATION_ALARM = '运营告警',
  STOP = '停车',
  LOW_BATTERY = '电量',
  LOW_PRESSURE = '胎压',
}

export enum CategoryType {
  CONNECTION_LOST = 'CONNECTION_LOST',
  INTERSECTION_EXCEPTION = 'INTERSECTION_EXCEPTION', // 路口异常
  VEHICLE_CRASH = 'VEHICLE_CRASH',
  SENSOR_ERROR = 'SENSOR_ERROR',
  OPERATION_ALARM = 'OPERATION_ALARM',
  STOP = 'STOP',
  LOW_BATTERY = 'LOW_BATTERY',
  LOW_PRESSURE = 'LOW_PRESSURE',
}
export enum SingleTabType {
  DRIVABLE = 'DRIVABLE',
  EXCEPTION = 'EXCEPTION',
  OPERATION = 'OPERATION',
  ACCIDENT = 'ACCIDENT',
}

export enum PncTaskType {
  UNKNOWN_TYPE = 'UNKNOWN_TYPE',
  NOTREADY = 'NOTREADY',
  ACTIVE = 'ACTIVE',
  ACCOMPLISHED = 'ACCOMPLISHED',
  CANCELLED = 'CANCELLED',
}

export const GeerPosition: any = {
  '0': 'N',
  '1': 'D',
  '2': 'R',
  '3': 'P',
};

export enum ThreeDimensionTaskState {
  INIT = 'INIT',
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}

export enum VideoState {
  CREATED = 'CREATED',
  FINISH = 'FINISH',
}

export const AlarmEventList = [
  {
    label: '防撞',
    value: 'VEHICLE_CRASH',
  },
  {
    label: '传感器异常',
    value: 'SENSOR_ERROR',
  },
  {
    label: '运营',
    value: 'OPERATION_ALARM',
  },
  {
    label: '开机异常',
    value: 'BOOT_ALARM',
  },
  {
    label: '路口异常',
    value: 'INTERSECTION_EXCEPTION',
  },
  {
    label: '停车',
    value: 'STOP',
  },
  {
    label: '电量',
    value: 'LOW_BATTERY',
  },
  {
    label: '胎压',
    value: 'LOW_PRESSURE',
  },
];

export const STOP_ENUM = [
  'VEHICLE_STOP_STOP_TAKEUP', // 停靠点被占
  'VEHICLE_STOP_STOP_ADJUST', // 停靠点调整失败
  'VEHICLE_STOP_FATAL', // 异常停车
  'VEHICLE_STOP_BUTTON', // 按钮停车
  'VEHICLE_STOP_TIMEOUT', // 遇阻停车
  'VEHICLE_STOP_GUARDIAN', // 安全接管停车
  'GATE_STUCK', // 过门遇阻
];

export const InterSectionException = [
  'VEHICLE_STOP_TRAFFICLIGHT_FAIL', // 看灯失败
  'VEHICLE_STOP_INTERSECTION_STUCK', // 路口遇阻
  'VEHICLE_STOP_TRAFFICLIGHT_TAKEUP', // 看灯点被占
  'PASS_NO_SIGNAL_INTERSECTION', // 无保护左转
  'VEHICLE_STOP_TRAFFICLIGHT_ADJUST', // 看灯规划失败
];

export const BOOT_ALARM = [
  'BOOT_FAIL', // 开机失败
  'BOOT_TIMEOUT', // 开机过久
  'BOOT_ABNORMAL', // 异常重启
  'BOOT_ABNORMAL_FAIL', // 异常重启失败
];
export const _PageSizeOptions = ['10', '20', '40', '100'];

export enum TerminalInputKey {
  BACK = 'Backspace',
  ENTER = 'Enter',
  SPACE = 'Space',
}
export enum ModalFormType {
  Edit = 'edit',
  Add = 'add',
}

export enum AccidentType {
  INITIATIVE_CRASH = 'INITIATIVE_CRASH',
  PASSIVE_CRASH = 'PASSIVE_CRASH',
  BRAKES_REAR_END = 'BRAKES_REAR_END',
  SCRATCH = 'SCRATCH',
  OTHER = 'OTHER',
  NONE = 'NONE',
  WAIT_CONFIRM = 'WAIT_CONFIRM',
}

export const AccidentTypeList = [
  {
    label: '主动碰撞',
    value: AccidentType.INITIATIVE_CRASH,
  },
  {
    label: '被动碰撞',
    value: AccidentType.PASSIVE_CRASH,
  },
  {
    label: '急刹追尾',
    value: AccidentType.BRAKES_REAR_END,
  },
  {
    label: '剐蹭',
    value: AccidentType.SCRATCH,
  },
  {
    label: '其他事故',
    value: AccidentType.OTHER,
  },
  {
    label: '无事故',
    value: AccidentType.NONE,
  },
  {
    label: '待确认',
    value: AccidentType.WAIT_CONFIRM,
  },
];

export enum AccidentSource {
  VEHICLE_REPORT = 'VEHICLE_REPORT', // 车端上报
  MANUALLY_CREATED = 'MANUALLY_CREATED', // 手动创建
}

export enum AccidentStatus {
  WAIT = 'WAIT',
  EFFICIENT = 'EFFICIENT',
  INVALID = 'INVALID',
  FALSE_ALARM = 'FALSE_ALARM',
}

export const AccidentStatusList = [
  {
    label: '待排查',
    value: AccidentStatus.WAIT,
  },
  {
    label: '有效事故',
    value: AccidentStatus.EFFICIENT,
  },
  {
    label: '无效事故',
    value: AccidentStatus.INVALID,
  },
  {
    label: '误报问题',
    value: AccidentStatus.FALSE_ALARM,
  },
];

export enum EVENTTYPE {
  ACCIDENT = 'accident',
  EVENT = 'event',
}

export enum JIRA_PRIORITY {
  URGENT = '1', // 紧急
  IMPORTANT = '2', // 重要
  GENERAL = '3', // 一般
  SECONDARY = '4', // 次要
  IRRELEVANT = '5', // 无关紧要
}

export enum JIRA_SOURCE {
  ISSUE = 'ISSUE',
  ACCIDENT = 'ACCIDENT',
}

export enum CommonCategory {
  VEHICLE_ALARM = 'VEHICLE_ALARM_CATEGORY_ENUM',
}
export const LOCALIZATION_ACCURACY: any = {
  LOCALIZATION_ACCURACY_0: {
    key: '',
    value: '无信号',
    icon: no_signal,
    className: 'no-signal',
  },
  LOCALIZATION_ACCURACY_1: {
    key: '',
    value: '信号差',
    icon: signal_1,
    className: 'no-signal',
  },
  LOCALIZATION_ACCURACY_2: {
    key: '',
    value: '信号较差',
    icon: signal_2,
    className: 'have-signal',
  },
  LOCALIZATION_ACCURACY_3: {
    key: '',
    value: '信号一般',
    icon: signal_3,
    className: 'have-signal',
  },
  LOCALIZATION_ACCURACY_4: {
    key: '',
    value: '信号较好',
    icon: signal_4,
    className: 'have-signal',
  },
  LOCALIZATION_ACCURACY_5: {
    key: '',
    value: '信号佳',
    icon: signal_5,
    className: 'have-signal',
  },
};

export enum ChannelType {
  WS = 'WS',
  MQTT = 'MQTT',
}

export enum TopicPath {
  COCKPIT_TEAM_GROUP = 'r/drive/cockpitTeamInfo/group/', // 驾驶团队信息
  USERINFO = 'r/drive/userInfo/', // 用户信息
  SCREEN_DATA = 'r/drive/screen/data/', // 云端数据统计
}

export enum CockpitType {
  MONITOR_SEAT = 'MONITOR_SEAT',
  COCKPIT_SEAT = 'COCKPIT_SEAT',
}

export enum CockpitTypeText {
  MONITOR_SEAT = '监控', //监控座席
  COCKPIT_SEAT = '驾舱', //驾舱座席
}
export enum CockpitMode {
  MONITOR = 'MONITOR', // 未进入座席页面
  PATROL_MODE = 'PATROL_MODE', // 巡查模式
  LISTENING_MODE = 'LISTENING_MODE', // 听单模式
  WATCH_CAR_MODE = 'WATCH_CAR_MODE', // 盯车模式
  MAP_COLLECTION_MODE = 'MAP_COLLECTION_MODE', // 地图采集模式
  FREE_MODE = 'FREE_MODE', // 自由模式
}
export enum CockpitModeText {
  MONITOR = '未进入座席页面',
  PATROL_MODE = '巡查模式',
  LISTENING_MODE = '听单模式',
  WATCH_CAR_MODE = '盯车模式',
  MAP_COLLECTION_MODE = '采图模式',
  FREE_MODE = '自由模式',
}

export enum CockpitStatus {
  OFFLINE = 'OFFLINE',
  WORK = 'WORK',
  REST = 'REST',
}

// 接单状态
export enum AcceptIssueStatus {
  ACCEPT = 'ACCEPT',
  STOP = 'STOP',
}
// 工单类型
export enum IssueType {
  OPS = 'OPS', // 运维工单
  PROBLEM_REPORT = 'BUG_REPORT', // 问题提报工单
}
export const IssueTypeText = new Map([
  ['OPS', '运维工单'],
  ['BUG_REPORT', '问题提报工单'],
]);

export enum IssueStatus {
  TO_ASSIGN = 'TO_ASSIGN',
  PROCESS = 'PROCESS',
  ON_HOLD = 'ON_HOLD',
  COMPLETE = 'COMPLETE',
  FORCE_CLOSE = 'FORCE_CLOSE',
  WAIT_ACCEPT = 'WAIT_ACCEPT',
  DISCARD_WAIT_ASSIGN = 'DISCARD_WAIT_ASSIGN',
  AUTO_CLOSE = 'AUTO_CLOSE',
}

export const IssueStatusText = new Map([
  [IssueStatus.TO_ASSIGN, '待分配'],
  [IssueStatus.DISCARD_WAIT_ASSIGN, '抛单待分配'],
  [IssueStatus.ON_HOLD, '挂单中'],
  [IssueStatus.PROCESS, '受理中'],
  [IssueStatus.AUTO_CLOSE, '自动关闭'],
  [IssueStatus.COMPLETE, '已解决'],
  [IssueStatus.FORCE_CLOSE, '强制关闭'],
  ['urgent', '紧急工单'],
]);

export const TicketOperation = new Map([
  [
    'TICKET_CREATE',
    {
      code: 'TICKET_CREATE',
      name: '工单创建',
      keOperation: true,
    },
  ],
  [
    'TICKET_ACCEPT',
    {
      code: 'TICKET_ACCEPT',
      name: '工单受理',
      keOperation: true,
    },
  ],
  [
    'TICKET_HOLD',
    {
      code: 'TICKET_HOLD',
      name: '工单挂起',
      keOperation: true,
    },
  ],
  [
    'TICKET_CANCEL_HOLD',
    {
      code: 'TICKET_CANCEL_HOLD',
      name: '工单取消挂起',
      keOperation: true,
    },
  ],
  [
    'TICKET_TRANSFER',
    {
      code: 'TICKET_TRANSFER',
      name: '工单转单',
      keOperation: true,
    },
  ],
  [
    'TICKET_DISCARD',
    {
      code: 'TICKET_DISCARD',
      name: '工单抛单',
      keOperation: true,
    },
  ],
  [
    'TICKET_REMIND',
    {
      code: 'TICKET_REMIND',
      name: '工单催单',
      keOperation: true,
    },
  ],
  [
    'TICKET_CLOSE',
    {
      code: 'TICKET_CLOSE',
      name: '工单关闭',
      keOperation: true,
    },
  ],
  [
    'VEHICLE_OPERATION',
    {
      code: 'VEHICLE_OPERATION',
      name: '车辆操作',
      keOperation: false,
    },
  ],
  [
    'EVENT_CHANGE',
    {
      code: 'EVENT_CHANGE',
      name: '事件变更',
      keOperation: false,
    },
  ],
]);

export const MqttTopic = {
  TEAM_INFO: `r/${process.env.JDX_APP_MQTT_ENV}/drive/cockpitTeamInfo/group/`,
  USER_INFO: `r/${process.env.JDX_APP_MQTT_ENV}/drive/userInfo/`,
  ISSUE_INFO: `r/${process.env.JDX_APP_MQTT_ENV}/drive/drawer/`,
  MQTT_WILL: `r/${process.env.JDX_APP_MQTT_ENV}/drive/monitor/will/`,
};

export enum AlarmEventType {
  UNKNOWN = '',
  VEHICLE_STOP_BUTTON = '按钮停车',
  VEHICLE_STOP_FATAL = '异常停车',
  VEHICLE_STOP_GUARDIAN = '安全接管停车',
  VEHICLE_STOP_TIMEOUT = '遇阻停车',
  VEHICLE_CRASH = '碰撞',
  LOW_BATTERY = '电量低',
  LOW_PRESSURE = '胎压异常',
  SENSOR_ERROR = '传感器异常',
  OPERATION_ALARM = '运营报警',
  VEHICLE_STOP_TRAFFICLIGHT_FAIL = '感知看灯失败',
  VEHICLE_STOP_INTERSECTION_STUCK = '路口遇阻',
  VEHICLE_STOP_TRAFFICLIGHT_TAKEUP = '看灯点被占',
  VEHICLE_STOP_TRAFFICLIGHT_ADJUST = '看灯规划失败',
  VEHICLE_STOP_STOP_TAKEUP = '停靠点被占',
  VEHICLE_STOP_STOP_ADJUST = '停靠规划失败',
  VEHICLE_CONNECTION_LOST = '车辆失联',

  //前端告警
  VEHICLE_SPEED_SLOW = '持续低速',
}

export const MapUpdaterStatusEnum = {
  TO_UPGRADE: {
    key: 0,
    name: '待生效',
  },
  TO_DOWNLOAD: {
    key: 1,
    name: '待下载',
  },
  DOWNLOADING: {
    key: 2,
    name: '下载中',
  },
  DOWNLOADED: {
    key: 3,
    name: '待升级',
  },
  UPGRADE: {
    key: 4,
    name: '升级中',
  },
  SUCCESS: {
    key: 5,
    name: '升级成功',
  },
  FAILURE: {
    key: 6,
    name: '升级失败',
  },
};

export enum MapUpdaterStatus {
  TO_UPGRADE = 0,
  TO_DOWNLOAD = 1,
  DOWNLOADING = 2,
  DOWNLOADED = 3,
  UPGRADE = 4,
  SUCCESS = 5,
  FAILURE = 6,
}
//事故快照视频截取状态
export const VideoCaptureStatus = new Map([
  ['capturing', '截取中'],
  ['success', '截取成功'],
  ['fail', '截取失败'],
]);

export enum VehicleSupplier {
  JD = 'JD',
  NEOLIX = 'NEOLIX',
  RINO = 'RINO',
}

export enum VehicleSupplierText {
  JD = '京东',
  NEOLIX = '新石器',
  RINO = '白犀牛',
}

export const VideoDirection = new Map([
  ['FRONT', '前路视频'],
  ['BACK', '后路视频'],
  ['LEFT', '左路视频'],
  ['RIGHT', '右路视频'],
]);

export const SingleViewRightTabConfig = {
  [SingleTabType.DRIVABLE]: {
    name: '使能情况',
    index: 0,
    value: SingleTabType.DRIVABLE,
    clstag: clstagStr(CLSTAG.EnableTab),
  },
  [SingleTabType.ACCIDENT]: {
    name: '事故排查',
    index: 1,
    value: SingleTabType.ACCIDENT,
    clstag: clstagStr(CLSTAG.Accident_investigation),
  },
  [SingleTabType.EXCEPTION]: {
    name: '错误信息',
    index: 2,
    value: SingleTabType.EXCEPTION,
    clstag: clstagStr(CLSTAG.ErrorInfoTab),
  },
  [SingleTabType.OPERATION]: {
    name: '操作日志',
    index: 3,
    value: SingleTabType.OPERATION,
    clstag: clstagStr(CLSTAG.OperationLog),
  },
};

export enum AccidentLevel {
  NONE = 'NONE',
  S0 = 'S0',
  S1 = 'S1',
  S2 = 'S2',
  S3 = 'S3',
  S4 = 'S4',
}

export const accidentLevelTooltipMap = {
  [AccidentLevel.S0]: '轻微碰撞且无人员伤害',
  [AccidentLevel.S1]: '碰撞且无人员伤害',
  [AccidentLevel.S2]: '碰撞且人员轻伤',
  [AccidentLevel.S3]: '碰撞且严重人员伤害',
  [AccidentLevel.S4]: '碰撞且人员致命伤害',
};

export enum whetherIncludeStatisticsEnum {
  INCLUDE = 1,
  NOT_INCLUDE = 0,
}

export const whetherIncludeStatisticsMap = [
  {
    value: whetherIncludeStatisticsEnum.INCLUDE,
    label: '是',
  },
  {
    value: whetherIncludeStatisticsEnum.NOT_INCLUDE,
    label: '否',
  },
];

// 充电状态枚举
export enum ChargeStateEnum {
  UNKNOWN = 'UNKNOWN',
  DISCHARGING = 'DISCHARGING',
  CHARGING = 'CHARGING',
  CHARGE_OK = 'CHARGE_OK',
}

// 插枪状态枚举
export enum ChargerConnectEnum {
  CHARGER_UNKNOWN = 'CHARGER_UNKNOWN',
  CHARGER_CONNECT = 'CHARGER_CONNECT',
  CHARGER_DISCONNECT = 'CHARGER_DISCONNECT',
}

// 充电状态文案映射
export const chargeStateLabelMap = {
  [ChargeStateEnum.CHARGING]: '充电中',
  [ChargeStateEnum.CHARGE_OK]: '充电完成',
  [ChargeStateEnum.DISCHARGING]: '未充电',
  [ChargeStateEnum.UNKNOWN]: '未知',
};

// 插枪状态文案映射
export const chargerConnectLabelMap = {
  [ChargerConnectEnum.CHARGER_CONNECT]: '已连接',
  [ChargerConnectEnum.CHARGER_DISCONNECT]: '未连接',
  [ChargerConnectEnum.CHARGER_UNKNOWN]: '未知',
};
